import { MatDialog } from '@angular/material/dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

import { AppServerAPI } from '@sdbn/common';
import { ResponseStatus } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { TerminalTransportRegistration, TerminalTransportRegistrationResult } from '../../model/terminal/transport-registration.model';
import { BarcodeScan } from '@sdbn/tmc-common';

export class TransportRegistrationWithCodeController extends AbstractStepController {

  private dialogService: DialogService;

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }
  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === TerminalContextConstants.registrationCode
      && contextChange.value != null && contextChange.value.replace(/\s+/g, '').length > 0) {
      this.onRegistrationCode();
    } else if (contextChange.key === 'barcodeScanned') {
      this.onBarcodeScanned();
    }
  }

  onRegisterToDashboardContext() {

  }

  onRegistrationCode() {

    const appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
    return appServerAPI.execute(`/terminal/registration/code`, {
      code: this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode)
    }).toPromise().then((response: TerminalTransportRegistration) => {
      this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
      this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
      if (response.status !== ResponseStatus.FAILED) {

        const registration = new TerminalTransportRegistration(response);

        this.dashboardContext.setContextValue(TerminalContextConstants.carrier, registration.carrier);
        this.dashboardContext.setContextValue(TerminalContextConstants.supplier, registration.supplier);
        this.dashboardContext.setContextValue(TerminalContextConstants.driver, registration.driver);
        this.dashboardContext.setContextValue(TerminalContextConstants.coDriver, registration.coDriver);
        this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
        this.dashboardContext.setContextValue(TerminalContextConstants.trailerNumberPlate, registration.trailerNumberPlate);
        this.dashboardContext.setContextValue(TerminalContextConstants.orderReference, registration.orderReference);
        this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
        this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
        this.dashboardContext.setContextValue(TerminalContextConstants.selectedOptions, registration.selectedOptions);
        this.dashboardContext.setContextValue(TerminalContextConstants.phoneNumber, registration.phoneNumber);
        this.dashboardContext.setContextValue('string1', registration.string1);
        this.dashboardContext.setContextValue('string2', registration.string2);
        this.dashboardContext.setContextValue('planningDate', registration.planningDate);
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('register with code finished');

        if (this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStepRegistrationCode) {
          this.wizardComponent.next(this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStepRegistrationCode);
        } else {
          this.wizardComponent.next();
        }

      } else {
        this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
      }
    }, error => {
      //this.dashboardContext.setContextValue('errorM', );
    });
  }

  onBarcodeScanned() {

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
    this.validateRegistrationCodeAndGetTransportData();
  }

  private validateRegistrationCodeAndGetTransportData() {
    const appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);

    const barcodeScan = new BarcodeScan({ value: this.dashboardContext.getContextValue('barcodeScanned') });
    appServerAPI.execute('/terminal/registration/transport/barcode', barcodeScan)
      .toPromise().then((response: TerminalTransportRegistrationResult) => {

        this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
        this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
        if (response.status !== ResponseStatus.FAILED) {

          const registration = new TerminalTransportRegistration(response);

          this.dashboardContext.setContextValue(TerminalContextConstants.carrier, registration.carrier);
          this.dashboardContext.setContextValue(TerminalContextConstants.supplier, registration.supplier);
          this.dashboardContext.setContextValue(TerminalContextConstants.driver, registration.driver);
          this.dashboardContext.setContextValue(TerminalContextConstants.coDriver, registration.coDriver);
          this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
          this.dashboardContext.setContextValue(TerminalContextConstants.trailerNumberPlate, registration.trailerNumberPlate);
          this.dashboardContext.setContextValue(TerminalContextConstants.orderReference, registration.orderReference);
          this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
          this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
          this.dashboardContext.setContextValue(TerminalContextConstants.selectedOptions, registration.selectedOptions);
          if (this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStepQrCodeScanned) {
            this.wizardComponent.next(this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStepQrCodeScanned);
          } else {
            this.wizardComponent.next();
          }
        } else {
          this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
        }
      }, error => {
        // TODO specify what happens for bad codes
      });
  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('register with code started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {

    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(result => {
      if (result) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    });

  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    const showCreateNewRegistrationButton = this.wizardComponent.currentStep.dashboardConfiguration?.showCreateNewRegistrationButton;
    if (showCreateNewRegistrationButton === true) {
      this.dashboardContext.setContextValue('newRegistrationEnabled', true);
      const newRegistrationControl = new StepControl();
      newRegistrationControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.button.alternative';
      newRegistrationControl.type = StepControlType.BUTTON_STROKED;
      newRegistrationControl.iconAfterCss = 'fa-thin fa-angle-right';
      newRegistrationControl.controlAction = () => {
        this.wizardComponent.stopInactivityMonitoring();
        if (this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep != null) {
          this.wizardComponent.next(this.wizardComponent.currentStep.dashboardConfiguration?.nextProcessStep);
        } else {
          this.wizardComponent.next('transport-registration-masterdata');
        }
      };
      controls.push(newRegistrationControl);
    } else {
      this.dashboardContext.setContextValue('newRegistrationEnabled', false);
    }
    this.dashboardContext.setContextValue('qrCodeScanEnabled', this.wizardComponent.currentStep.dashboardConfiguration?.qrCodeScanEnabled == true);

    this.dashboardContext.setContextValue('registrationCodeMinLength', this.wizardComponent.currentStep.dashboardConfiguration?.registrationCodeMinLength);
    this.dashboardContext.setContextValue('registrationCodeMaxLength', this.wizardComponent.currentStep.dashboardConfiguration?.registrationCodeMaxLength);

    return controls;

  }
}
